import { render, staticRenderFns } from "./CreateRecette.vue?vue&type=template&id=be59a094&"
import script from "./CreateRecette.vue?vue&type=script&lang=js&"
export * from "./CreateRecette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports